import React from "react";
import "./is3.scss";
import { IoIosPeople } from "react-icons/io";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";

export default () => {
  const data = useStaticQuery(graphql`
    query is3 {
      image1: file(
        relativePath: { eq: "components/pages/index/is3/img1.jpg" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image2: file(
        relativePath: { eq: "components/pages/index/is3/img2.jpg" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image3: file(
        relativePath: { eq: "components/pages/index/is3/img3.jpg" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      image4: file(
        relativePath: { eq: "components/pages/index/is3/img4.jpg" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <>
      <div className="tdate">
        <a href="https://www.occupationalenglishtest.org/test-information/test-dates-locations/">
          Test dates & locations
        </a>
      </div>
      <div className="is3 container">
        <div className="title">
          <h2>Popular Courses</h2>
        </div>
        <div className="cards">
          <div className="is3-card">
            <div>
              <Img fluid={data.image1.childImageSharp.fluid} />
            </div>
            <div className="card-content">
              <Link to="/oet-test-information">
                <h5>OET</h5>
              </Link>
              <p>The best in-class training program in Ahmedabad </p>
              <hr />
              <div className="icn">
                <i>
                  <IoIosPeople />
                </i>
                <p>100</p>
              </div>
            </div>
          </div>
          <div className="is3-card">
            <div>
              <Img fluid={data.image2.childImageSharp.fluid} />
            </div>
            <div className="card-content">
              <Link to="/ielts-test-information">
                <h5>IELTS</h5>
              </Link>
              <p>
                In-class assistance with the latest eminities encompassing all
                the Modules.
              </p>
              <hr />
              <div className="icn">
                <i>
                  <IoIosPeople />
                </i>
                <p>100</p>
              </div>
            </div>
          </div>
          {/* <div className="is3-card">
          <div>
            <Img fluid={data.image3.childImageSharp.fluid} />
          </div>
          <div className="card-content">
            <h5>IELTS</h5>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Obcaecati, totam?
            </p>
            <hr />
            <div className="icn">
              <i>
                <IoIosPeople />
              </i>
              <p>100</p>
            </div>
          </div>
        </div>
        <div className="is3-card">
          <div>
            <Img fluid={data.image4.childImageSharp.fluid} />
          </div>
          <div className="card-content">
            <h5>IELTS</h5>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Obcaecati, totam?
            </p>
            <hr />
            <div className="icn">
              <i>
                <IoIosPeople />
              </i>
              <p>100</p>
            </div>
          </div>
        </div> */}
        </div>
      </div>
    </>
  );
};
